import React, { useCallback, useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import s from './collapse.module.css';
import useSlots from '../../hooks/use-slots';
import { openedContext, useAccordion } from './utils';
import { Title } from './slots';
import { containsNode } from '../../utils/dom';
const Item = ({ children, title, opened: externalOpened = false, onToggle = () => { }, itemProp, itemScope, itemType, variant, }) => {
    const [selected, setSelected] = useState(externalOpened);
    const control = useRef(null);
    const content = useRef(null);
    const slots = useSlots('Collapse', children);
    useEffect(() => setSelected(externalOpened), [externalOpened]);
    const { toggle } = useAccordion(control);
    const handleToggleEvent = useCallback(({ detail }) => {
        if (!control.current || (content.current && containsNode(content.current, detail.target))) {
            return;
        }
        const currentState = control.current.open;
        toggle();
        setSelected(!currentState);
        if (!detail.artificial) {
            onToggle(!currentState, detail.event);
        }
    }, [toggle, onToggle]);
    useEffect(() => {
        if (!control.current) {
            return;
        }
        const el = control.current;
        el.addEventListener('uikit:collapse-toggle', handleToggleEvent);
        return () => {
            el.removeEventListener('uikit:collapse-toggle', handleToggleEvent);
        };
    });
    const handleClick = useCallback((event) => {
        if (!content.current || !containsNode(content.current, event.target)) {
            event.preventDefault();
        }
    }, []);
    return (React.createElement("details", Object.assign({ className: classNames(s.item, variant && { [s[variant]]: selected }), open: externalOpened, ref: control, onClick: handleClick }, { itemProp, itemScope, itemType }),
        React.createElement(openedContext.Provider, { value: selected },
            React.createElement("summary", null, title ? React.createElement(Title, null, title) : slots.title),
            React.createElement("div", { ref: content, "data-content": true, className: s.content }, slots.children))));
};
export default Item;
//# sourceMappingURL=item.js.map